import React, { useState } from 'react';

import PostData from '../../services/PostData.js'
import SnackbarEx from '../Helpers/SnackbarEx.jsx';
import { Button, TextField, Typography, IconButton } from "@mui/material";
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CloseIcon from '@mui/icons-material/Close'

export default function AddNewDescription({ close }) {
    const [submitLoad, setSubmitLoad] = useState(false)
    const [successAdd, setSuccessAdd] = useState(false)
    const [description, setDescription] = useState({
        template: null,
        description: ""
    })


    const submitUpdate = async () => {
        setSubmitLoad(true)
        const { success, error: postError, load: postLoad } = await PostData(description, "broylesllc/add-ebay-descriptions", null)

        if (success) {
            setSubmitLoad(false)
            setSuccessAdd(true)
            setTimeout(() => {
                close()
            }, 1000)
        }
    }


    return (
        <>
            <div style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                // paddingTop: "20px",
                padding: "10px 10px 0 10px",
                boxSizing: 'border-box'
            }}>
                {/* <div style={{ marginBottom: '10px' }}>
                    <Typography variant="h5" component="h1" sx={{ fontWeight: 700, color: '#101828', fontSize: '18px !important' }}>
                        Update eBay Listing Description:
                    </Typography>
                </div> */}
                <div className="card-header bg-white"
                    style={{ borderBottom: '1px solid #f0f0f0' }}
                >
                    <Typography variant="h5" component="h1" sx={{ padding: '10px' }}>
                        Add new description:
                    </Typography>
                    <IconButton
                        onClick={() => close()}
                        sx={{
                            position: 'absolute', width: '40px', height: '40px', top: '10px', right: '30px',
                            // boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                            backgroundColor: 'white', zIndex: 100, "&:hover": { backgroundColor: '#f0f0f0' }
                        }}
                    >
                        <CloseIcon sx={{ cursor: 'pointer' }} />
                    </IconButton>
                </div>

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',
                    flex: 1,
                    minHeight: 0,
                    padding: '5px 20px'
                }}>
                    <TextField
                        label="Template Name"
                        // helperText={"Add the description HTML"}
                        size="small"
                        value={description.template}
                        onChange={(e) => setDescription({ ...description, ['template']: e.target.value })}
                        sx={{
                            flexGrow: 1,
                            marginTop: '10px',
                            '& .MuiInputBase-input': {
                                height: '100% !important',
                                overflow: 'auto !important',
                            }

                        }}
                    />

                    <TextField
                        label="Description"
                        // helperText={"Add the description HTML"}
                        multiline
                        size="small"
                        value={description.description}
                        onChange={(e) => setDescription({ ...description, ['description']: e.target.value })}
                        minRows={11}
                        error={description?.description.length > 4000}
                        helperText={
                            description?.description.length > 4000
                                ? `Description is over eBay's 4000 characters title limit .. current length: ${description?.description.length}`
                                : "Add the description HTML"
                        }
                        sx={{
                            flexGrow: 1,
                            '& .MuiInputBase-root': {
                                height: '350px',
                                alignItems: 'flex-start',
                                overflow: 'hidden',
                            },
                            '& .MuiInputBase-input': {
                                height: '100% !important',
                                overflow: 'auto !important',
                            }

                        }}
                    />
                </div>

                {/* Footer remains at the bottom */}
                <div className='card-footer' style={{
                    padding: '16px 0',
                    borderTop: '1px solid #e0e0e0',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    background: 'white'
                }}>
                    <Button
                        variant="contained"
                        disableElevation
                        onClick={submitUpdate}
                        startIcon={successAdd && <CheckOutlinedIcon />}
                        loading={submitLoad}
                        sx={{ backgroundColor: successAdd ? "green" : '#3E5C76', width: '150px' }}
                    >
                        {successAdd ? "Added" : "Save"}
                    </Button>
                </div>
            </div>


        </>
    );
};